import api from '@utils/api';

const POLL_INTERVAL_MS = 5000;
const POLL_TIMEOUT_MS = 120000;
const isUploading = (item = {}) => item.asyncStatus === 'uploading' && item.picId;

const getStatusMessage = (status = {}) => ({
    asyncStatus: status.status === 'success' ? 'success' : status.status === 'fail' ? 'fail' : 'uploading',
    failureReason: status.status === 'fail'
        ? status.errorMessage || '图片处理或云存储上传失败，请稍后重试'
        : '',
});

export const stopUploadStatusReconcile = () => {
    if (window.localUploadStatusReconcileTimer) {
        clearTimeout(window.localUploadStatusReconcileTimer);
        window.localUploadStatusReconcileTimer = null;
    }
};

export const startUploadStatusReconcile = ({ flowId, onChange, onComplete, onTimeout }) => {
    stopUploadStatusReconcile();
    const startedAt = Date.now();

    const poll = async () => {
        const queue = window.fileListQueue;
        const currentList = queue && queue.getList ? queue.getList() : [];
        const picIds = currentList.filter(isUploading).map(item => item.picId);
        if (!picIds.length) {
            if (currentList.some(item => item.asyncStatus === 'uploading')) {
                window.localUploadStatusReconcileTimer = setTimeout(poll, POLL_INTERVAL_MS);
            }
            return;
        }

        try {
            const response = await api(`/lossAss/shotPics/status?flowId=${encodeURIComponent(flowId)}&picIds=${encodeURIComponent(picIds.join(','))}`).get();
            if (response && response.errCode === 0) {
                const statusByPicId = (response.result && response.result.pics || [])
                    .reduce((result, item) => Object.assign(result, { [item.picId]: item }), {});
                currentList.forEach((item, index) => {
                    const status = statusByPicId[item.picId];
                    if (!status || !isUploading(item)) return;
                    const next = getStatusMessage(status);
                    if (next.asyncStatus !== item.asyncStatus || next.failureReason !== item.failureReason) {
                        queue.update(index, { ...item, ...next });
                    }
                });
                const nextList = queue.getList();
                if (onChange) onChange(nextList);
                if (!nextList.some(isUploading)) {
                    if (onComplete) onComplete(nextList);
                    return;
                }
            }
        } catch (error) {
            // Socket 仍是主通道；对账失败不改变本地上传状态，等待下一轮。
        }

        if (Date.now() - startedAt >= POLL_TIMEOUT_MS) {
            const latestList = queue.getList();
            let changed = false;
            latestList.forEach((item, index) => {
                if (!isUploading(item)) return;
                queue.update(index, {
                    ...item,
                    asyncStatus: 'pending',
                    failureReason: '图片仍在后台处理，请稍后刷新页面查看最终结果',
                });
                changed = true;
            });
            if (changed && onTimeout) onTimeout(queue.getList());
            return;
        }
        window.localUploadStatusReconcileTimer = setTimeout(poll, POLL_INTERVAL_MS);
    };

    window.localUploadStatusReconcileTimer = setTimeout(poll, POLL_INTERVAL_MS);
};
